import React from 'react'

const ProductivityReportIcon = (props) => {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.4" d="M21.5867 2.66602H10.4267C5.57338 2.66602 2.68005 5.55935 2.68005 10.4127V21.5727C2.68005 26.426 5.57338 29.3193 10.4267 29.3193H21.5867C26.44 29.3193 29.3334 26.426 29.3334 21.5727V10.4127C29.3334 5.55935 26.44 2.66602 21.5867 2.66602Z" fill="#0057FF" />
            <path d="M13.4799 14.8672H9.94661C9.10661 14.8672 8.42664 15.5471 8.42664 16.3871V23.2138H13.4799V14.8672V14.8672Z" fill="#0057FF" />
            <path opacity="0.4" d="M17.0133 8.80078H14.9867C14.1467 8.80078 13.4667 9.4808 13.4667 10.3208V23.2008H18.52V10.3208C18.52 9.4808 17.8533 8.80078 17.0133 8.80078Z" fill="#0057FF" />
            <path d="M22.0667 17.1348H18.5333V23.2015H23.5867V18.6548C23.5733 17.8148 22.8933 17.1348 22.0667 17.1348Z" fill="#0057FF" />
        </svg>
    )
}

export default ProductivityReportIcon